import { THREE } from "../config/ThreeConfig.js";

function clamp01(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(1, n));
}

export async function createPostFX(renderer, scene, camera, options = {}) {
  const width = Math.max(1, Number(options.width) || 1);
  const height = Math.max(1, Number(options.height) || 1);
  const pixelRatio = Math.max(1, Math.min(2, Number(options.pixelRatio) || 1));

  // Dynamic imports: only load when bloom is enabled for capable desktop sessions.
  const [{ EffectComposer }, { RenderPass }, { UnrealBloomPass }] = await Promise.all([
    import("three/examples/jsm/postprocessing/EffectComposer.js"),
    import("three/examples/jsm/postprocessing/RenderPass.js"),
    import("three/examples/jsm/postprocessing/UnrealBloomPass.js"),
  ]);

  const composer = new EffectComposer(renderer);
  if (typeof composer.setPixelRatio === "function") composer.setPixelRatio(pixelRatio);
  composer.setSize(width, height);
  composer.addPass(new RenderPass(scene, camera));

  // Subtle bloom for bright additive FX only (lasers/explosions), keep threshold high.
  const bloomStrength = Math.max(0, Number(options.bloomStrength) || 0.22);
  const bloomRadius = Math.max(0, Number(options.bloomRadius) || 0.18);
  const bloomThreshold = clamp01(options.bloomThreshold ?? 0.92);

  const bloom = new UnrealBloomPass(new THREE.Vector2(width, height), bloomStrength, bloomRadius, bloomThreshold);
  bloom.enabled = true;
  composer.addPass(bloom);

  return {
    composer,
    bloomPass: bloom,
    setSize(w, h) {
      composer.setSize(Math.max(1, Number(w) || 1), Math.max(1, Number(h) || 1));
    },
    dispose() {
      try {
        composer.dispose?.();
      } catch {
        // ignore
      }
    },
  };
}
